<!-- <div class="container mt-5 pt-5 mt-md-5 pt-md-5"> -->
<div class="container">
  <!-- <div class="row align-items-center justify-content-center">
        <p>best-dex works!</p>
      </div> -->
  <div class="card card1">
    <div class="best-dex-wrapper">
      <div class="">
        <div class="dex_icon1 mt-5 mb-4">
          <img src="/assets/images/dex_icon1.svg" alt="" />
        </div>
        <div class="d-flex justify-content-center">
          <div class="card card2 d-block">
            <div>
              <div>
                <p class="swap mb-0">{{ "swap" | translate }}</p>
              </div>

              <div class="d1 mt-3">
                <div>
                  <p class="count1 mb-0">1.2</p>
                </div>
                <div>
                  <img class="ethimg" src="/assets/images/crypto/ETH_Frame.png" alt="" srcset="" />
                </div>
              </div>

              <div class="d1">
                <div>
                  <p class="count2 mb-0">$2663.83</p>
                </div>

                <div>
                  <span class="count2">{{ "balance" | translate }}: 1.2</span>
                  <span class="max">{{ "MAX" | translate }}</span>
                </div>
              </div>

              <div class="d1 mt-3">
                <div>
                  <p class="count1 mb-0">2225.6</p>
                </div>
                <div>
                  <img class="usdt_frame" src="/assets/images/crypto/USDT_Frame.png" alt="" srcset="" />
                </div>
              </div>

              <div class="d1">
                <div>
                  <p class="count2 mb-0">$2225.97(-0.31%)</p>
                </div>
                <div>
                  <p class="count2 mb-0">{{"balance" | translate}}: 0</p>
                </div>
              </div>

              <div class="tarde-btn-div mt-5">
                <a class="tarde-btn" href="https://bestdex.com" target="_blank">{{ "btn-tradeNow" | translate }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro mt-5">
        <p class="dexb-p1">{{ "Introducing" | translate }}</p>
        <h2 class="dexb-p2">{{ "best-dex" | translate }}</h2>
        <p class="dexb-p3">{{ "dexb-p3" | translate }}</p>
        <p class="dexb-p3">{{ "dexb-p4" | translate }}</p>
        <p class="dexb-p3">{{ "dexb-p5" | translate }}</p>

        <p class="dexb-link">
          <a href="https://bestdex.com" target="_blank">{{ "dexb-link" | translate }}
            <img class="dexb-linkicon" src="/assets/images/Link.svg" alt="" srcset="" />
          </a>
        </p>
      </div>
    </div>
  </div>
</div>